/**
 * Copyright © 2018 Emu Analytics
 */

import { Client } from './client';
import { WebSocketSubscribeCallback, WebSocketUnsubscriber } from './web-socket-gateway';

export class AppConfigEndpoints {
  constructor(private readonly client: Client) {}

  private get resourceEndpoint(): string {
    return `/api/v1/appconfig`;
  }

  get(path?: string, params: Record<string, any> = {}): Promise<any> {
    return this.client._get(path ? `${this.resourceEndpoint}/${path}` : this.resourceEndpoint, { params });
  }

  set(path: string | null, value: any, params: Record<string, any> = {}): Promise<any> {
    // Wrap primitives in value object
    if (
      typeof value === 'string' ||
      typeof value === 'number' ||
      typeof value === 'boolean' ||
      value === null ||
      Array.isArray(value)
    ) {
      value = { value };
    }

    return this.client._put(path ? `${this.resourceEndpoint}/${path}` : this.resourceEndpoint, value, {
      headers: {
        'Content-Type': 'application/json'
      },
      params
    });
  }

  delete(path: string, params: Record<string, any> = {}): Promise<any> {
    return this.client._delete(`${this.resourceEndpoint}/${path}`, { params });
  }

  subscribe(cb: WebSocketSubscribeCallback): WebSocketUnsubscriber {
    return this.client._subscribe('appconfig', cb);
  }
}
